export default Object.freeze({
  date: 'date',
  capitalize: 'capitalize',
  price: 'price',
});
